import { PlainMessage } from "@bufbuild/protobuf";
import { Attachment, UploadAttachment } from "protogen/common_pb";
import { FactStub, FactSectionStub } from "protogen/facts_pb";
import { Family } from "protogen/advisors_service_pb";
import { attachmentsToUploads } from "../creation/FileUploader";
import { getFormattedLocation } from "components/family/utils";
import { prettyFamilyStatus } from "components/family/types";

export type EphemeralFact = {
  ref?: string;
  name: string;
  value: string;
  valueType: string;
  attachments: Attachment[];
  uploads: PlainMessage<UploadAttachment>[];
  // Used for associating a task with where it was made.
  sourceEntityType?: string;
  sourceEntityRef?: string;
  sourceEntityIndex?: number;
  sortOrder?: number;
  sectionRef?: string;
};

export type EphemeralFactSection = {
  ref?: string;
  name: string;
  sortOrder?: number;
};

export type FormErrors = {
  [key: string]: string;
};

export type FactFormProps = {
  fact: EphemeralFact;
  sections: FactSectionStub[];
  updateFormData: (
    f: EphemeralFact | ((f_: EphemeralFact) => EphemeralFact),
  ) => void;
  errors: FormErrors | null;
};

export type FactSectionFormProps = {
  factSection: EphemeralFactSection;
  updateFormData: (f: EphemeralFactSection) => void;
  errors: FormErrors | null;
};

export type FactFormHandle = {
  isValid: () => boolean;
};

export const buildEphemeralFact = (fact: FactStub): EphemeralFact => {
  return {
    ref: fact.ref,
    name: fact.name,
    value: fact.value,
    valueType: fact.valueType,
    attachments: fact.attachments || [],
    uploads: attachmentsToUploads(fact.attachments || []),
    sectionRef: fact.sectionRef,
  };
};

export const buildEphemeralFactSection = (
  factSection: FactSectionStub,
): EphemeralFactSection => {
  return {
    ref: factSection.ref,
    name: factSection.name,
    sortOrder: factSection.sortOrder,
  };
};

export const createFamilyDetailsFactStub = (family: Family): FactStub => {
  const values = [
    `Location: ${getFormattedLocation(family.address)}`,
    `Status: ${prettyFamilyStatus(family.status)}`,
    `Members: ${family.familyMembers.length}`,
  ];
  return new FactStub({
    ref: "FamilyDetails",
    name: `${family.name} Family`,
    valueType: "family",
    value: values.join("\n"),
    attachments: [],
  });
};
